(() => {
    class ManageCampaignTemplateCommsSetupController {
        /**
         * @type {CampaignTemplate}
         */
        campaignTemplate;
        userContext;

        hasSMS = false;
        hasPush = false;
        hasInbox = false;

        constructor(
            $scope,
            ErrorService,
            CampaignDesignerService,
            SMSHelperService,
            StoresService,
            LocalisationService,
            notify,
            $state,
            $sce,
            $uibModal,
            $timeout,
            DashboardConfig
        ) {
            this.$scope = $scope;
            this.ErrorService = ErrorService;
            this.CampaignDesignerService = CampaignDesignerService;
            this.SMSHelperService = SMSHelperService;
            this.StoresService = StoresService;
            this.LocalisationService = LocalisationService;
            this.notify = notify;
            this.$state = $state;
            this.$sce = $sce;
            this.$uibModal = $uibModal;
            this.$timeout = $timeout;
            this.DashboardConfig = DashboardConfig;

            this.SMSTextAreaSelector = "#SMSTextArea";
            this.PushTextAreaSelector = "#PushTextArea";
            this.CodeEditor = document
                .getElementById("InboxMessage");
            this.doesEditorHaveSelection = false;
        }

        get hasCommunication() {
            return !!this.hasSMS || !!this.hasPush || !!this.hasInbox;
        }

        /**
         * Initialises the controller and sets up the scope variables, permissions and grids
         */
        $onInit() {
            this.CampaignCommunicationTextReplacementService = new CampaignCommunicationTextReplacementService(
                this,
                this.userContext.BrandId,
                this.StoresService,
                this.ErrorService,
                this.DashboardConfig
            ).initialiseForCampaign(this.campaignTemplate);

            this.InboxTemplates = [];
            this.invalidVariables = [];

            this.isBrandContext = this.campaignTemplate.CampaignLevelId === Dashboard.Models.Lookups.CampaignLevels.Brand;
            this.stores = [];

            this.CampaignTemplateCommunicationTypes = Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes;


            this.loadTemplates();
        }

        clearCommunication() {
            this.communication = new window.Dashboard.Models.CampaignTemplateCommunication();
            this.hasSMS = false;
            this.hasInbox = false;
            this.hasPush = false;
            this.MinSendTime = this.LocalisationService.combineDateTime(new Date(), this.communication.MinSendTime);
            this.MaxSendTime = this.LocalisationService.combineDateTime(new Date(), this.communication.MaxSendTime);
            this.resetWatches();
        }

        scrollToTop() {
            window.scrollTo({
                left: 0,
                top: 0
            });
        }

        loadCommunication(communicationData) {
            if (!communicationData) {
                return this.clearCommunication();
            }
            const communication = new window.Dashboard.Models.CampaignTemplateCommunication()
                .initialiseCampaignTemplateCommunication(communicationData);

            if (communication.PushNotification === null) {
                communication.PushNotification = new Dashboard.Models.TextMessage();
                communication.InboxMessage = new Dashboard.Models.InboxMessage();
            }

            if (communication.SMS === null) {
                communication.SMS = new Dashboard.Models.TextMessage();
            }

            this.MinSendTime = this.LocalisationService.combineDateTime(new Date(), communication.MinSendTime);
            this.MaxSendTime = this.LocalisationService.combineDateTime(new Date(), communication.MaxSendTime);

            this.SMSTextCharCount = 0;
            this.SMSMessagePartCount = 1;
            this.SMSTextPreview = "";
            this.PushTextPreview = "";
            this.selectedTemplateId = 0;
            this.InboxMessagePreview = "";

            this.hasSMS = communication.HasSMS();
            this.hasPush = communication.HasPushNotification();
            this.hasInbox = communication.HasInboxMessage();

            this.communication = communication;
            this.resetWatches();
            if (!this.communication.Name || !this.communication.Description) {
                this.scrollToTop();
            }
        }

        readCommunicationValue(fn) {
            if (!this.communication) {
                return "";
            }
            return fn(this.communication);
        }

        runIfHaveCommunication(fn) {
            if (!this.communication) {
                return;
            }
            fn();
        }

        resetWatches() {
            if (this.$scope.SMSWatch) {
                this.$scope.SMSWatch();
            }
            if (this.$scope.PushWatch) {
                this.$scope.PushWatch();
            }
            if (this.$scope.InboxWatch) {
                this.$scope.InboxWatch();
            }
            if (this.$scope.NameWatch) {
                this.$scope.NameWatch();
            }
            if (this.$scope.CommuncationWatch) {
                this.$scope.CommunicationWatch();
            }
            this.$scope.CommunicationWatch = this.$scope.$watch(
                () => this.communication,
                () => {
                    if (!this.communication) {
                        this.hasSMS = false;
                        this.hasPush = false;
                        this.hasInbox = false;
                    }
                });
            this.$scope.SMSWatch = this.$scope.$watch(
                () => this.readCommunicationValue(() => this.communication.SMS.Text),
                () => this.runIfHaveCommunication(() => this.onSMSTextChanged())
            );
            this.$scope.PushWatch = this.$scope.$watch(
                () => this.readCommunicationValue(() => this.communication.PushNotification.Text),
                () => this.runIfHaveCommunication(() => this.onPushTextChanged())
            );
            this.$scope.InboxWatch = this.$scope.$watch(
                () => this.readCommunicationValue(() => this.communication.InboxMessage.Text),
                () => this.runIfHaveCommunication(() => this.onInboxMessageChanged())
            );
            this.$scope.NameWatch = this.$scope.$watch(
                () => this.readCommunicationValue(() => this.communication.Name),
                () => {
                    if (!this.communication) {
                        return;
                    }
                    // this is paranoia boilerplating: the maxlength
                    // attribute on the input should prevent filling
                    // in too much content, but just in case there's a
                    // way to bypass (you used to be able to bypass on
                    // at least some browsers by pasting), we can double-check
                    // here. The database cannot accept > 50 chars.
                    this.communication.Name = this.communication.Name || "";
                    if (this.communication.Name.length > 50) {
                        this.communication.Name = this.communication.Name.substring(0, 50);
                        this.ErrorService.showError(
                            "Communication name may not exceed 50 characters"
                        );
                    }
                }
            );
        };

        /**
         * Set the editors value when the inbox message changes
         */
        onInboxMessageChanged() {
            this.editorContent = this.communication.InboxMessage.Template
        };

        /**
         * Loads the inbox templates
         */
        loadTemplates() {
            this.$scope.$root.isLoading = true;
            this.CampaignDesignerService.getInboxTemplatesForBrand(this.userContext.BrandId)
                .then(result => {
                        this.InboxTemplates = _.map(result.data, item => {
                            return new Dashboard.Models.InboxTemplate().initialiseInboxTemplate(item);
                        });
                    }
                )
                .catch(result =>
                    this.ErrorService.showError('An error occurred when loading the campaign template', result)
                ).finally(() =>
                this.$scope.$root.isLoading = false
            );
        };

        /**
         * Updates the sms counts and preview message when the SMS message changes
         */
        onSMSTextChanged() {
            this.SMSTextPreview = this.replaceVariables(
                Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.sms
            );
            const SMSCountObject = this.SMSHelperService.getSMSCount(
                this.SMSTextPreview, null, null, 0, 0
            );
            this.SMSMessagePartCount = SMSCountObject.smsCount;
            this.SMSTextCharCount = SMSCountObject.charCountTotal;
        };

        /**
         * Updates the push message preview when the Push message changes
         */
        onPushTextChanged() {
            this.PushTextPreview = this.replaceVariables(
                Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.push
            );
        };

        /**
         * Replaces the message variable placeholders with the content
         */
        replaceVariables(messageType) {
            if (!this.userContext) {
                throw new Error(`Can't replace variables in message: no user context set`);
            }
            return this.CampaignCommunicationTextReplacementService.replaceVariables(
                messageType,
                this.userContext.BrandName,
                this.editorContent,
                this.communication
            );
        };

        variablesAreValid() {
            this.invalidVariables = this.CampaignCommunicationTextReplacementService.listAllInvalidVariables(
                this.editorContent,
                this.communication
            );
            return this.invalidVariables.length === 0;
        }

        /**
         * Sets the inbox message details to the selected template
         */
        onTemplateChanged() {
            const selectedTemplate = _.find(this.InboxTemplates, (template) => {
                return template.TemplateId === this.selectedTemplateId;
            });


            this.communication.InboxMessage.Blurb = selectedTemplate.Description;
            this.communication.InboxMessage.Template = selectedTemplate.Content;
            this.editorContent = selectedTemplate.Content;
        }


        /**
         * Saves the communication and continues to the next step
         */
        submitPage() {
            if (!this.hasSMS &&
                !this.hasPush &&
                !this.hasInbox
            ) {
                this.ErrorService.showError('Campaign Communication needs at least one message', null);
                return;
            }

            this.$scope.$root.isLoading = true;
            this.SetInboxMessageAndValidateModel();
            if (!this.variablesAreValid()) {
                this.invalidVariables.forEach(invalid => {
                    const communicationTypes = Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes;
                    const communicationTypeLabel = Object.keys(communicationTypes)
                        [Object.values(communicationTypes).indexOf(invalid.propertyType)];
                    this.ErrorService.showError(`An error occurred. ${invalid.propertyName}
                 from a ${communicationTypeLabel} message is not a valid variable name`);
                });
                return;
            }
            this.communication.MinSendTime = this.LocalisationService.formatDateTime(
                this.MinSendTime, "HH:mm"
            );
            this.communication.MaxSendTime = this.LocalisationService.formatDateTime(
                this.MaxSendTime, "HH:mm"
            );

            const cleanedUpCommunication = this.cleanupCommunication();
            const validationPassed = cleanedUpCommunication.Validate(this.ErrorService);

            if (!validationPassed) {
                return;
            }
            this.CampaignDesignerService.updateCampaignTemplateCommunication(
                this.campaignTemplate.TemplateGuid,
                cleanedUpCommunication,
                false
            ).then(result => {
                    this.notify.success('The campaign template was successfully saved');
                    cleanedUpCommunication.reInitializeCommunicationProperties();
                    if (cleanedUpCommunication.Id === 0) {
                        cleanedUpCommunication.Id = result.data;
                        this.campaignTemplate.Communications.push(cleanedUpCommunication);
                    } else {
                        const foundIndex = this.campaignTemplate.Communications.findIndex(
                            x => x.Id === cleanedUpCommunication.Id
                        );
                        this.campaignTemplate.Communications[foundIndex] = cleanedUpCommunication;
                    }

                    this.loadCommunication(undefined);
                }
            ).catch(err =>
                this.ErrorService.showError(
                    'An error occurred when saving the campaign template', err
                )
            ).finally(
                () => this.$scope.$root.isLoading = false
            );
        }

        /**
         * Sets the inbox message details and validates the model
         */
        SetInboxMessageAndValidateModel() {
            if (this.hasInbox) {
                if (!this.communication.InboxMessage) {
                    this.communication.InboxMessage = new Dashboard.Models.InboxMessage();
                }
                this.communication.InboxMessage.Template = this.editorContent;

                if (!this.communication.PushNotification.ExclusionRule) {
                    this.communication.PushNotification.ExclusionRule = new Dashboard.Models.ExclusionRules();
                }
            }
        }

        /**
         * Cleans up the communication model to be sent to the API
         * If we are not sending through an SMS or Pushnotification , then these values should be null
         */
        cleanupCommunication() {
            const newCopy = angular.copy(this.communication);
            if (!this.hasSMS) {
                newCopy.SMS = undefined;
            }

            if (!this.hasPush) {
                newCopy.PushNotification = undefined;
            }

            if (!this.hasInbox) {
                newCopy.InboxMessage = undefined;
            }

            return newCopy;
        }

        getCommunicationTypeTags(communication) {
            const tags = [];
            if (communication.HasSMS()) {
                tags.push("SMS");
            }

            if (communication.HasPushNotification()) {
                tags.push("Push");
            }

            if (communication.HasInboxMessage()) {
                tags.push("Inbox");
            }

            return tags.join(", ");
        };

        getCommunicationOffsetStartDays(communication) {
            return communication.EarliestOffsetFromStart + " - " + communication.LatestOffsetFromStart + " days";
        };

        getCommunicationSendTimes(communication) {
            const minSendTime = this.LocalisationService.combineDateTimeAndFormat(
                null, communication.MinSendTime, "LT"
            );
            const maxSendTime = this.LocalisationService.combineDateTimeAndFormat(
                null, communication.MaxSendTime, "LT"
            );
            return minSendTime + " - " + maxSendTime;
        };

        deleteTemplateConfirmation(communication) {
            const confirmationModal = this.$uibModal.open({
                animation: true,
                templateUrl: 'components/campaigndesigner/managecampaigntemplates/commssetup/deleteconfirmationmodal.311a7587.html',
                controller: 'DeleteConfirmationModalController',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    communicationName: function () {
                        return communication.Name;
                    }
                }
            });

            confirmationModal
                .result
                .then(result => {
                    if (result) {
                        const communicationId = communication.Id;
                        this.deleteTemplate(communicationId);
                    }
                });
        };

        deleteTemplate(communicationId) {
            this.$scope.$root.isLoading = true;

            this.CampaignDesignerService.removeCampaignTemplateCommunication(
                this.campaignTemplate.TemplateGuid,
                communicationId
            ).then(() => {
                this.campaignTemplate.Communications = _.reject(
                    this.campaignTemplate.Communications,
                    campaignTemplateCommunication => campaignTemplateCommunication.Id === communicationId
                );
                this.loadCommunication(undefined);
                this.notify.success("The campaign communication was successfully removed.");
            }).catch(err => {
                const error = new Error("An error occurred while removing the communication.");
                this.ErrorService.showError(
                    error.message,
                    err
                );
            }).finally(() => {
                this.$scope.$root.isLoading = false;
            });
        };

        goNext() {
            if (this.preventNavigationDueToActiveEdit()) {
                return;
            }
            this.$state.go(
                Dashboard.helpers.stateHelper.getParentState(
                    this.$state.current.name
                ) + ".menuscripts", {
                    brandId: this.userContext.BrandId,
                    CampaignTemplateGuid: this.campaignTemplate.TemplateGuid
                });
        };

        goBack() {
            if (this.preventNavigationDueToActiveEdit()) {
                return;
            }
            this.$state.go(
                Dashboard.helpers.stateHelper.getParentState(
                    this.$state.current.name
                ) + ".vouchers", {
                    brandId: this.userContext.BrandId,
                    CampaignTemplateGuid: this.campaignTemplate.TemplateGuid
                });
        }

        preventNavigationDueToActiveEdit() {
            if (!this.haveUnsavedChanges()) {
                return false;
            }
            return !window.confirm(
                window.Dashboard.helpers.heredoc(`
                    You are currently editing a communication.

                    Are you sure you'd like to discard any unsaved changes?`
                )
            );
        }

        haveUnsavedChanges() {
            return this.communication.Id > 0 ||
                this.hasSMS ||
                this.hasPush ||
                this.hasInbox;
        }

    }

    class ManageCampaignTemplateCommunicationsSetupController extends ManageCampaignTemplateCommsSetupController {
        static maxFileSizeInBytes = 204800;

        /**
         * @type HTMLElement
         */
        $el;

        constructor(
            $scope,
            ErrorService,
            CampaignDesignerService,
            SMSHelperService,
            StoresService,
            LocalisationService,
            notify,
            $state,
            sce,
            uibModal,
            $timeout,
            $log,
            DashboardConfig,
            CKEditorService,
            $element
        ) {
            super($scope,
                ErrorService,
                CampaignDesignerService,
                SMSHelperService,
                StoresService,
                LocalisationService,
                notify,
                $state,
                sce,
                uibModal,
                $timeout,
                $log,
                DashboardConfig
            );
            this.$el = $element[0];
            this.logger = $log;
            this.scope = $scope;
            this.timeout = $timeout;

            this.uibModal = uibModal;
            this.campaignDesignerService = CampaignDesignerService;
            this.dashboardConfig = DashboardConfig;
            this.file = undefined;
            this.featuredImageUploadError = undefined;
            this.featuredImageUrl = undefined;
            this.notifyService = notify;
            this.uploadInProgress = false;
            this.editorContent = undefined;
            this.editorService = CKEditorService;
            this.boundInsertVariable = (type, value) => this.insertVariable(
                type,
                value
            );
            this.setupTemplateEditor();
            this.editTemplate(undefined);
            this.CampaignTemplateCommunicationTypes = window.Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes;
        }

        editTemplate(communication) {
            if (!communication) {
                this.loadCommunication(undefined);
                return;
            }
            this.loadCommunication(communication);
            if (this.communication.HasInboxMessage()) {
                this.editorContent = communication.InboxMessage.Template;
            }
        }

        setupTemplateEditor() {
            this.editorConfig = {
                language: 'en',
                allowedContent: true,
                fullPage: true,
                extraPlugins: 'sourcedialog',
                removePlugins: 'sourcearea',
                versionCheck: false
            };
        }

        smsOrPushToggled() {
            this.$timeout(() => {
                if (!this.communication) {
                    throw new Error(`push notification somehow toggled without the editor being open?`);
                }
                if (this.hasSMS && this.hasPush) {
                    this.communication.SMS.ExclusionRule.CanPush = true;
                }
            });
        }

        insertVariable(messageType, variable) {
            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox) {
                return this.editorService.insertHTML(this.createFormattedInboxVariable(variable));
            }

            if (messageType === Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.sms) {
                return this.communication.SMS.Text = this.insertTextAtCursorPosition(
                    this.getSMSTextAreaCursorPosition(),
                    this.communication.SMS.Text,
                    `{${variable}}`);

            }

            this.communication.PushNotification.Text = this.insertTextAtCursorPosition(
                this.getPushTextAreaCursorPosition(),
                this.communication.PushNotification.Text,
                `{${variable}}`);
        };

        getSMSTextAreaCursorPosition() {
            return $(this.SMSTextAreaSelector).prop("selectionStart");
        }


        getPushTextAreaCursorPosition() {
            return $(this.PushTextAreaSelector).prop("selectionStart");
        }

        resolveFeaturedImageUrl(url) {
            if (!url) {
                return url;
            }

            const sanitizedUrl = /^http(s?)\:\/\//.test(url) ?
                url : `${this.getUrlScheme()}//` + url.replace(/^[\:\/]*/, "")


            return this.dashboardConfig.ImageResizeServiceUrl
                ? `${this.dashboardConfig.ImageResizeServiceUrl}?url=${encodeURIComponent(sanitizedUrl)}`
                : sanitizedUrl
        }

        getUrlScheme() {
            return location.protocol
        }

        createFormattedInboxVariable(variable) {
            if (variable === 'FeaturedImage') {
                return this.featuredImageUrl ? `<img src="${this.featuredImageUrl}" alt="Campaigns featured image" />` : "";
            }
            return `@Raw(Model.${variable})`;
        }

        insertTextAtCursorPosition(
            cursorPosition,
            originalText,
            newText
        ) {
            originalText = originalText || "";
            newText = newText || "";
            return [
                originalText.slice(0, cursorPosition),
                newText,
                originalText.slice(cursorPosition)
            ].join('');
        }

        previewInboxMessage() {
            return this.CampaignCommunicationTextReplacementService.replaceVariables(
                Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox,
                this.userContext.BrandName,
                this.editorContent,
                this.communication
            );
        };

        openPreview(messageType, message) {
            this.uibModal.open({
                animation: true,
                templateUrl: 'components/campaigndesigner/managecampaigntemplates/commssetup/preview.a57bac9e.html',
                controller: 'PreviewModalController',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    messageType: function () {
                        return messageType;
                    },
                    message: function () {
                        return message;
                    }
                }
            });
        }

        $postLink() {
            this.featuredImageUrl = this.resolveFeaturedImageUrl(this.campaignTemplate.FeaturedImageResourceUrl);
            const el = document.querySelector('#getFile');
            el
                ? el.onchange = (event) => this.uploadFeaturedImage(event.target.files)
                : undefined;
        }

        uploadFeaturedImage(files) {
            const maximumFileSizeInKB = ManageCampaignTemplateCommunicationsSetupController.maxFileSizeInBytes / 1024;
            this.uploadInProgress = true;
            for (const file of files) {
                if (file.size > ManageCampaignTemplateCommunicationsSetupController.maxFileSizeInBytes) {
                    return this.scope.$apply(
                        () => {
                            this.featuredImageUploadError = `The file ${file.name} exceeds the maximum file size - ${maximumFileSizeInKB}KB`;
                            this.uploadInProgress = false;
                        }
                    );
                }
            }
            this.featuredImageUploadError = false;
            this.campaignDesignerService.uploadFeaturedImage(this.campaignTemplate.TemplateGuid, files)
                .then(response => {
                    this.uploadInProgress = false;
                    this.featuredImageUrl = this.resolveFeaturedImageUrl(response.data);
                })
                .catch(e => {
                    this.uploadInProgress = false;
                    this.logger.error(e)
                    this.featuredImageUploadError = "Unable to upload the featured image";
                })
        }

        clearFeaturedImage() {
            this.campaignDesignerService.clearFeaturedImage(this.campaignTemplate.TemplateGuid)
                .then(() => this.featuredImageUrl = undefined)
                .catch(e => {
                    const message = "Unable to remove the featured image"
                    this.logger.error(message, e)
                    this.notifyService.error(message)
                })
        }

    }

    window.ManageCampaignTemplateCommunicationsSetupController = ManageCampaignTemplateCommunicationsSetupController

    angular
        .module('dashboard')
        .component('manageCampaignTemplateComms', {
            templateUrl: 'components/campaigndesigner/managecampaigntemplates/commssetup/campaigntemplatecommssetup.c2cc3efb.html',
            bindings: {
                campaignTemplate: '=',
                userContext: '<'
            },
            controller: [
                '$scope',
                'ErrorService',
                'CampaignDesignerService',
                'SMSHelperService',
                'StoresService',
                'LocalisationService',
                'notify',
                '$state',
                '$sce',
                '$uibModal',
                '$timeout',
                '$log',
                'DashboardConfig',
                'CKEditorService',
                "$element",
                ManageCampaignTemplateCommunicationsSetupController
            ]
        });

})();
